export default {"src":"https://fishbrain.com/_next/static/media/georgia.b18dd38c.svg","height":128,"width":128,"blurWidth":0,"blurHeight":0};